import { render, staticRenderFns } from "./RemotePhoto.vue?vue&type=template&id=596a8b78&scoped=true"
import script from "./RemotePhoto.vue?vue&type=script&lang=js"
export * from "./RemotePhoto.vue?vue&type=script&lang=js"
import style0 from "./RemotePhoto.vue?vue&type=style&index=0&id=596a8b78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a8b78",
  null
  
)

export default component.exports